<template>
    <div>
        <button class="ontario-button ontario-button--secondary mb-5" @click="nextPage" :disabled="nextDisabled()">{{ changeButtonText }}</button>
    </div>
</template>

<script>

export default {
  props: ['page', 'lastPage', 'limit', 'hasMore', 'fetchingResults'],
  data () {
    return {

    }
  },
  computed: {
    changeButtonText: function () {
      let buttonText = ""
      if (this.fetchingResults) {
        buttonText = this.$t("message_loading")
      } 
      else if (this.nextDisabled()) {
        buttonText = this.$t("message_no_more")
      }
      else
      {
        buttonText = this.$t("message_next", {'limit': this.limit})
        // buttonText = this.$t("message_next")
      }
      return buttonText
    }
  },
  methods: {
    nextPage () {
      // Cast this.page to an int because it's an int on the homepage and a string on the search page
      this.$emit('update-page', parseInt(this.page) + 1)
    },
    // If the current page + 1 exceeds the last page, disable the next page button
    nextDisabled () {
      // Cast this.page and this.lastPage to an int because of the string/int mismatch
      if (parseInt(this.page) + 1 > parseInt(this.lastPage) || !this.hasMore) {
        return true
      }
    }
  }
}
</script>